<template>
  <div>
    <template v-for="field in fields">
      <RangeInput v-if="field.type == 'range-input'" :key="field.name" :fields="field" />
      <TagInput
        v-else-if="field.type == 'tag-input'"
        :key="field.name"
        :fields="field"
        :items="formValues[field.name]"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
      />
      <ValueHelpWrapper
        v-else-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput v-else :key="field.name" v-bind="field" />
    </template>
  </div>
</template>

<script>
import RangeInput from './wrapper/RangeInput'
import TagInput from './wrapper/TagInput'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import { getTableFilterFields } from './lib/tableFilterFields'

export default {
  components: {
    RangeInput,
    TagInput,
    ValueHelpWrapper,
  },
  props: {
    formValues: {},
    fullObjects: {},
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      fields: [],
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateFields()
    },
  },
  mounted() {
    this.updateFields()
  },
  methods: {
    updateFields() {
      this.fields = getTableFilterFields().filter((field) => field.isShow)
    },
  },
}
</script>
